import { makeAutoObservable } from "mobx";
import {
  classifiersLoader,
  deleteCassifiers,
  ZClassifier,
} from "src/business/classifier";
import { RtStore } from "src/components/ReactiveTable/RtStore";

export type MClsFilters = {};

export const managementClassifiersStore = makeAutoObservable({
  tableStore: new RtStore<ZClassifier, MClsFilters>({
    rowKey: "id",
    loader: classifiersLoader,
    selectionType: "checkbox",
  }),
  async deleteRows() {
    const ids = this.tableStore.selectedKeys as string[];
    await deleteCassifiers(ids);
    this.tableStore.setSelectedKeys([]);
    this.tableStore.onDataChanged();
  },
});
